module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/landing-mobile-logo.2f4da3d4.png";